import { SAMPLE_TEMPLATES, type SampleTemplate } from '../data/templates';

export class TemplateGallery {
  readonly el = document.createElement('dialog');
  private list = document.createElement('div');
  constructor(private select: (template: SampleTemplate) => void) {
    this.el.className = 'hdp-template-dialog';
    this.el.setAttribute('aria-label', 'Sample templates');
    this.el.innerHTML = `<div class="hdp-template-heading"><div><span class="hdp-eyebrow">A HEAD START FOR YOUR NEXT IDEA</span><h2>Ten themes. Endless possibilities.</h2><p>Complete, responsive pages with original illustrations and rich content. No external assets needed.</p></div><button type="button" class="hdp-iconbtn" aria-label="Close templates">×</button></div><p class="hdp-template-note">Loading a template replaces the current document. Download your work first if you want to keep it.</p>`;
    this.list.className = 'hdp-template-list';
    this.el.append(this.list);
    this.el.querySelector('button')!.addEventListener('click', () => this.el.close());
    this.el.addEventListener('close', () => this.list.replaceChildren());
  }
  open(): void {
    this.list.replaceChildren();
    for (const template of SAMPLE_TEMPLATES) {
      const card = document.createElement('article');
      card.className = 'hdp-template-card';
      const preview = document.createElement('div');
      preview.className = 'hdp-template-preview';
      const loader = document.createElement('span');
      loader.className = 'hdp-template-loading';
      loader.textContent = 'Loading preview…';
      const frame = document.createElement('iframe');
      frame.title = `${template.name} template preview`;
      frame.setAttribute('sandbox', '');
      frame.setAttribute('loading', 'lazy');
      frame.tabIndex = -1;
      frame.setAttribute('aria-hidden', 'true');
      frame.addEventListener('load', () => { loader.hidden = true; });
      frame.srcdoc = template.html;
      preview.append(frame, loader);
      const info = document.createElement('div');
      info.className = 'hdp-template-info';
      const category = document.createElement('span'); category.className = 'hdp-eyebrow'; category.textContent = template.category;
      const name = document.createElement('h3'); name.textContent = template.name;
      const description = document.createElement('p'); description.textContent = template.description;
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'hdp-btn hdp-btn--primary';
      button.textContent = 'Use template'; button.setAttribute('aria-label', `Use ${template.name} template`);
      button.addEventListener('click', () => { this.select(template); this.el.close(); });
      info.append(category, name, description, button);
      card.append(preview, info);
      this.list.append(card);
    }
    this.el.showModal();
  }
  destroy(): void { this.el.close(); this.el.remove(); }
}
